import { render, staticRenderFns } from "./OtpInputResult.vue?vue&type=template&id=5c30e7de&scoped=true"
import script from "./OtpInputResult.vue?vue&type=script&lang=js"
export * from "./OtpInputResult.vue?vue&type=script&lang=js"
import style0 from "./OtpInputResult.vue?vue&type=style&index=0&id=5c30e7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c30e7de",
  null
  
)

export default component.exports